import module from 'colaborador/module.js'

export class CatalogoColaboradorPersonaService {
  constructor($http) {
    this.$http = $http
  }

  get (idProyecto, idColaborador) {
    return this.$http.get('/api/colaborador/persona', {
      params: {idProyecto, idColaborador},
    })
  }
}

module.service('CatalogoColaboradorPersona', CatalogoColaboradorPersonaService);



// WEBPACK FOOTER //
// ./src/colaborador/services/Catalogos/Persona.js